module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-02-d289afd4096b57207a1aef8e81f4a41b.jpg";